import { render } from "./CustomSelectOne.vue?vue&type=template&id=1d63a4c2&scoped=true"
import script from "./CustomSelectOne.vue?vue&type=script&lang=js"
export * from "./CustomSelectOne.vue?vue&type=script&lang=js"

import "./CustomSelectOne.vue?vue&type=style&index=0&id=1d63a4c2&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d63a4c2"]])

export default __exports__